import { IBobblehead, IEvent } from "./App";
import Firebase from "./firebase";
import PlayFab from "./Playfab/PlayFab";
//import { prizeID } from "./PlayFab/PlayFab";
//import Model from "./BobbleContent/ModelViewer/index";
//import ModelView from "./BobbleContent/ModelViewer/index";

export interface IUser {
  userId: string;
  email?: string;
}

export interface ICachedData {
  bobbleheads: {
    [key: string]: IBobblehead;
  };
  events: {
    [key: string]: IEvent;
  };
}

let urlString: string = "";

function getCurrentURL() {
  return urlString;
}

const getCurrentPrizeImage = (
  imageUrl: string
) => {
   //let urlString: string = "";
   if(urlString === "") {
    storageRef
      .child("Prizes/"+imageUrl+".png")
      .getDownloadURL()
      .then(function (url) {
        //Hardcoded URL until they have been added to the prizes custom data
        //console.log("returned url: " + url);
        urlString = url;
      }).catch(function (error) {
        console.log("Error getting prize image");
      });
  }
};

const setNewPrizeImage = (
  imageUrl: string
) => {
  storageRef
      .child("Prizes/"+imageUrl+".png")
      .getDownloadURL()
      .then(function (url) {
        //Hardcoded URL until they have been added to the prizes custom data
        //console.log("returned url: " + url);
        urlString = url;
      }).catch(function (error) {
        //console.log("Error getting prize image");
      });
};

export const getPrizeImage = (
  user: IUser | null,
  bobblehead: IBobblehead
): string => {
    //console.log(urlString);
    return urlString;
};

//To do: Change parameter name to better reflect email instead of number
const userExists = async (email: string) => {
  //console.log("setting user exists temp string");
  return false;
};

//returning hardcoded values as login is done anonymously
const checkAuthentication = async (): Promise<IUser | null> => {
  //console.log("Authenticating");
  var user: IUser = {
    userId: "",
    email: "anon@mlb.com",
  };

  return user;
};

const relogIn = async (email: string): Promise<any> => {
  PlayFab.ReturnUserLogin(email);
  let newUser: IUser = {
    userId: "",
    email: ""
  };
  newUser.email = email;
  newUser.userId = email;
  return newUser;
}

//Login currently handled in App index
const logIn = async (email: string): Promise<any> => {
  //console.log("logging in");
  PlayFab.DoExampleLoginWithCustomIDReal(email);
  let newUser: IUser = {
    userId: "",
    email: ""
  };
  newUser.email = email;
  newUser.userId = email;
  return newUser;
};

//not relevant for this iteration
const logOut = async () => {

};

const lookupBobblehead = async (
  bobbleheadId: string
): Promise<{
  bobblehead: IBobblehead;
  event: IEvent;
} | null> => {
  //console.log("lookupbobblehead");
  try {
    const response = await fetch(`/lookup/${bobbleheadId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response || !response.ok) {
      return null;
    }
    return response.json();
  } catch (e) {
    return null;
  }
};

const storageRef = Firebase.storage().ref();
//const databaseRef = Firebase.database().ref();

const lookup = async ({
  bobbleheadIds = [],
  eventIds = [],
}: {
  bobbleheadIds?: string[];
  eventIds?: string[];
}): Promise<ICachedData> => {

  //This is WIP code for pulling JSON for setting an IBobbleHead data

  /*const response = storageRef.child("Data/Seth.json")
  .getDownloadURL()
  .then(async function (url) {
    const response = await fetch(url, {
      body: JSON.stringify({
        bobbleheadIds,
        eventIds
      }),
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST"
    });
    if (!response || !response.ok) {
      console.log("No response");
      return { bobbleheads: {}, events: {} };
    }
    console.log("Proper response");
    console.log(response.json());
    return response.json();
  }).catch(function (error) {
    console.log("storage error");
    return { bobbleheads: {}, events: {} };
  })*/

  /*if(bobbleheadIds === []) {
    console.log("no bobblehead");
    return { bobbleheads: {}, events: {} };
  }*/

  //Hardcoded testing until additional model assets are given
  //PlayFab.SetCurrentBobble("AustinM");
  //HARDCODED IBOBBLEHEAD FOR TESTING
  var bobble: IBobblehead = {
    id: "0",
    eventId: "TampaBay",
    name: "Austin Meadows",
    modelUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fautin-meadows.glb?alt=media&token=ed44fbe0-be7b-4da4-976d-f836f027c3ca",    
    primaryLogoUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FSagicorUSARegisteredHorizontalColor.png?alt=media&token=98b41493-7543-4f35-839d-e6b7dd3667b6",
    baseSideTextureUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FbaseSideTexture.jpg?alt=media&token=abe9037c-d101-414f-b653-eca9926d019b",
    baseTextureUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FbaseTexture.jpg?alt=media&token=3507f2e5-b01d-4288-8f8d-f7fb201e4b44",
    scratchCoverUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FscratchSmaller.png?alt=media&token=37c2d763-8d17-41bc-808c-81864e7d2db0",
    silhouetteUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FQ%20mark%20silhoutte%20v3.png?alt=media&token=c729ad74-2885-406a-95a5-722064f95ef1",
    thumbnailUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fthumbnail-transparent.png?alt=media&token=b80acd85-be47-48b5-b6c7-50d5422165b6",
    modelScaleFactor: 350,
    modelOffsetY: 15,
    baseScaleFactor: 47,
    baseOffsetY: 15,
  };

  var bobble2: IBobblehead = {
    id: "1",
    eventId: "TampaBay",
    name: "Seth R",
    modelUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FSethBaseball_R1_NoBase.glb?alt=media&token=646c4b25-2c4e-4544-a5f0-1a9b6445e9e9",    
    primaryLogoUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FSagicorUSARegisteredHorizontalColor.png?alt=media&token=98b41493-7543-4f35-839d-e6b7dd3667b6",
    baseSideTextureUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fbase_side.jpg?alt=media&token=4a1e67f0-abf1-4e71-809f-718e8b962951",
    baseTextureUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fbase_top.jpg?alt=media&token=c48a8380-7172-481e-9313-16a95360f8a4",
    scratchCoverUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fscratch.png?alt=media&token=1162b662-1970-4498-ac58-4a7510d19975",
    silhouetteUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FQ%20mark%20silhoutte%20v3.png?alt=media&token=c729ad74-2885-406a-95a5-722064f95ef1",
    thumbnailUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fthumbnail%20-%20transparent.png?alt=media&token=1068905c-171a-49fc-b396-2ae8abf67c79",
    modelScaleFactor: 430,
    modelOffsetY: 20,
    baseScaleFactor: 50,
    baseOffsetY: 10,
  };

  var event: IEvent = {
    id: "TampaBay",
    bobbleheadIds: ["0", "1"],
    title: "Tampa Bay Rays",
    subtitle: "",
  };

  var bobbleM0: IBobblehead = {
    id: "M0",
    eventId: "NewYorkMets",
    name: "Mr. Met",
    modelUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FMr_Met_01_09_2020.glb?alt=media&token=c843b8d7-0840-4774-8743-f5c2139c81ce",    
    primaryLogoUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fciti_logo_RGB_Blue_Trasnparent.png?alt=media&token=12b4d111-98cf-47df-b330-00ca0f752264",
    baseSideTextureUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FMr_Met_Base_Side_Texture.jpg?alt=media&token=daffbb07-8799-407f-ae3a-9e9225650e4c",
    baseTextureUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2Fgrass%20base%20texture_MrMet.jpg?alt=media&token=598d4547-b34b-48fc-9dc4-99b5c9adf83e",
    scratchCoverUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FMr_Met_Bottom_Texture.jpg?alt=media&token=2d09a44c-9f20-4618-95b8-990ee5baa0a7",
    silhouetteUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FQ%20mark%20silhoutte%20v3.png?alt=media&token=c729ad74-2885-406a-95a5-722064f95ef1",
    thumbnailUrl: "https://firebasestorage.googleapis.com/v0/b/digital-giveaways-group.appspot.com/o/Bobble%2FMr_Met_Thumbnail.png?alt=media&token=7a79ff71-ec5f-4f0b-b868-eaa11430bd5d",
    modelScaleFactor: 90,
    modelOffsetY: 10,
    baseScaleFactor: 47,
    baseOffsetY: 10,
  };

  var event2: IEvent = {
    id: "NewYorkMets",
    bobbleheadIds: ["M0"],
    title: "New York Mets",
    subtitle: "",
  };

  const data = { bobbleheads: { "0": bobble, "1": bobble2, "M0": bobbleM0 }, events: { "0": event, "1": event2 } }; 
  //console.log("loaded data", { data });
  return data;

  //ORIGINAL CODE
  /*try {
    const response = await fetch(jsonURL, {
      body: JSON.stringify({
        bobbleheadIds,
        eventIds
      }),
      headers: {
        "Content-Type": "application/json"
      },
      method: "POST"
    });
    if (!response || !response.ok) {
      return { bobbleheads: {}, events: {} };
    }
    return response.json();
  } catch (e) {
    return { bobbleheads: {}, events: {} };
  }*/
};

export default {
  checkAuthentication,
  relogIn,
  logIn,
  logOut,
  lookup,
  lookupBobblehead,
  userExists,
  getCurrentPrizeImage,
  setNewPrizeImage,
  getCurrentURL
};
